import "./BtnStyle.scss";
import React, { memo } from "react";
import { Button } from "reactstrap";

const OutlineBtn = (props) => {
  const { className, text, handleOnClick, icon, disabled = false, type = "button" } = props;
  return (
    <Button
      className={`OutlineBtn buttonBoxShadow ${className}`}
      onClick={handleOnClick}
      disabled={disabled}
      type={type}
    >
      {text}
      {icon && icon}
    </Button>
  );
};

export default memo(OutlineBtn);
